<!-- elemento ripetuto -->
<button type="button" *ngIf="isSuperUser()" class="btn btn-xs btn-outline-primary btn-block mb-2" [class.alert-primary]="enable_editing" (click)="enable_editing=!enable_editing"><i class="fas fa-pencil-alt mr-1"></i>Modifica struttura</button>

<div class="form-group row mb-1" *ngIf="isListValid()"
    cdkDropList
     [cdkDropListDisabled]="!isSuperUser()"
     (cdkDropListDropped)="onDrop($event)" >    

    <ng-container *ngFor="let record of list;let i=index">   
        <ng-container *ngIf="checkEnableCondition(list,record.condition_enable_fieldname,record.condition_fieldname_value,record.access)">                                                            
            <ng-container *ngIf="isAgreed(record)"  >
                
                <!-- placeholder mostrato durante il trascinamento -->
                <div class="drag-placeholder" *cdkDragPlaceholder></div>                
                
                <div class="col-sm-12 record-row" *ngIf="record.type=='separator'" cdkDrag [cdkDragData]="record">
                    <hr class="my-1" *ngIf="record.label!=''" />
                    <h5 class="text-primary mb-1" *ngIf="record.label!='' && record.show_label">{{record.label}}</h5>
                    <ng-container *ngIf="enable_editing">
                        <i title="Modifica separatore" class="editInRow fa fa-pencil-alt pointer" (click)="editInRow(record,i)"></i>
                        <i title="Sposta separatore" class="editInRow dragHandle fa fa-grip-vertical" cdkDragHandle title="Trascina per riordinare"></i>
                        <br/>
                    </ng-container>                    
                </div>

                <div *ngIf="record.type!='separator' && record.show_label"
                        [class.col-sm-2]="layout=='horizontal' || record.type!='table'" 
                        [class.col-sm-12]="layout=='vertical' || record.type=='table'" >
                    <label *ngIf="record.type!='hidden'" title="{{record.id_customfield}}">{{record.label}}</label>                    
                </div>
                
                <div *ngIf="record.type!='separator'"  class="align-middle mb-1" cdkDrag [cdkDragData]="record"
                        [class.col-sm-4]="layout=='horizontal' || record.type!='table'" 
                        [class.col-sm-12]="layout=='vertical' || record.type=='table'" >
                    <app-field [field]="record" [fields]="list" [noLabel]="true"></app-field>
                    <ng-container *ngIf="enable_editing">
                        <i title="Modifica campo {{record.type}}" class="editInRow fa fa-pencil-alt pointer" (click)="editInRow(record,i)"></i>
                        <i title="Sposta campo {{record.type}}" class="editInRow dragHandle fa fa-grip-vertical" cdkDragHandle title="Trascina per riordinare"></i>
                    </ng-container>
                </div>
                
            </ng-container>
        </ng-container>
    </ng-container>
    
    <button class="btn btn-xs btn-outline-success btn-block mt-2" *ngIf="enable_editing" (click)="addCustomField()"><i class="fas fa-plus-square mr-1"></i>Aggiungi campo</button>
</div>

<button type="button" class="btn btn-default btn-xs float-right" (click)="openImport()"><i class="fas fa-file-import mr-1"></i>Importa campi da file CSV</button>